import { createAction } from '@reduxjs/toolkit';
import type { MediaTrackErrorKey } from 'devices/types';

export const mediaSettingsActions = {
  cameraTrack: {
    cleanedUp: createAction('[Media Settings] camera track cleaned up'),
    creation: {
      started: createAction('[Media Settings] camera track creation started'),
      completed: createAction('[Media Settings] camera track creation completed'),
      failed: createAction<MediaTrackErrorKey>('[Media settings] camera track creation failed'),
    },
  },
  microphoneTrack: {
    cleanedUp: createAction('[Media Settings] microphone track cleaned up'),
    creation: {
      started: createAction('[Media Settings] microphone track creation started'),
      completed: createAction('[Media Settings] microphone track creation completed'),
      failed: createAction<MediaTrackErrorKey>('[Media Settings] microphone track creation failed'),
    },
  },
  noDevicesAlert: {
    openMediaSettingsButtonClicked: createAction('[NoDevicesAlert] open media settings button clicked'),
  },
  toggleMedia: {
    openVideoSettingsClicked: createAction('[ToggleMedia] open video settings button clicked'),
    openAudioSettingsClicked: createAction('[ToggleMedia] open audio settings button clicked'),
  },
};
